import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import FeedbackFilters from './FeedbackFilters';
import FeedbackRow from './FeedbackRow';
import PaginationFooter from '../../components/PaginationFooter';

const HEADERS = [
  { label: 'Tipo', align: 'left' },
  { label: 'Título', align: 'left' },
  { label: 'Usuário', align: 'left' },
  { label: 'Empresa', align: 'left' },
  { label: 'Tela', align: 'left' },
  { label: 'Status', align: 'left' },
  { label: 'Anexos', align: 'center' },
  { label: 'Data', align: 'left' },
  { label: 'Ações', align: 'right' },
];

/**
 * FeedbacksTable - Tabela da aba "Feedbacks" com filtros e paginação server-side (Admin Geral)
 * @param {Object} props
 * @param {Array} props.feedbacks
 * @param {boolean} props.isLoading
 * @param {string|null} props.error
 * @param {Object} props.pagination
 * @param {Object} props.filters - props repassadas ao FeedbackFilters
 * @param {Function} props.onPageChange
 * @param {Function} props.onView
 */
function FeedbacksTable({
  feedbacks = [],
  isLoading = false,
  error = null,
  pagination,
  filters,
  onPageChange,
  onView,
}) {
  return (
    <Paper
      sx={{
        borderRadius: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        border: '1px solid #E8ECF0',
        overflow: 'hidden',
      }}
    >
      <FeedbackFilters {...filters} />

      {error && (
        <Alert severity="error" sx={{ borderRadius: 0 }}>
          {error}
        </Alert>
      )}

      <TableContainer sx={{ boxShadow: 'none', borderRadius: 0 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#F8F9FC' }}>
              {HEADERS.map((h) => (
                <TableCell
                  key={h.label}
                  align={h.align}
                  sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.8125rem', whiteSpace: 'nowrap' }}
                >
                  {h.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 6 }}>
                  <CircularProgress size={32} />
                </TableCell>
              </TableRow>
            ) : feedbacks.length === 0 ? (
              <TableRow>
                <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 6 }}>
                  <Typography variant="body2" color="text.secondary">
                    Nenhum feedback encontrado
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              feedbacks.map((feedback) => (
                <FeedbackRow key={feedback.id} feedback={feedback} onView={onView} />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <PaginationFooter pagination={pagination} onPageChange={onPageChange} itemLabel="feedbacks" />
    </Paper>
  );
}

export default FeedbacksTable;
